import { DefectStatus } from '../../models/defect.model';
import { StatusKind } from '../../components/status-pill/status-pill.component';

export const DEFECT_STATUSES: readonly DefectStatus[] = ['OPEN', 'IN_PROGRESS', 'FIXED', 'VERIFIED', 'REJECTED'];

// Spiegel von DefectTransitions im Backend (ARCHITECTURE.md §3.7); ob VERIFIED einen bestandenen Nachtest hat, prueft nur der Server.
const NEXT: Record<DefectStatus, readonly DefectStatus[]> = {
  OPEN: ['IN_PROGRESS', 'FIXED', 'REJECTED'],
  IN_PROGRESS: ['OPEN', 'FIXED', 'REJECTED'],
  FIXED: ['OPEN', 'IN_PROGRESS', 'VERIFIED'],
  REJECTED: ['OPEN'],
  VERIFIED: [],
};

export function statusChoices(current: DefectStatus): DefectStatus[] {
  return [current, ...NEXT[current]];
}

const KIND: Record<DefectStatus, StatusKind> = {
  OPEN: 'fehler',
  IN_PROGRESS: 'laufend',
  FIXED: 'pending',
  VERIFIED: 'aktiv',
  REJECTED: 'inaktiv',
};

export function defectStatusKind(status: DefectStatus): StatusKind {
  return KIND[status];
}
